/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overlap_SuggestedInputs */

const en_overlap_suggested = /** @type {(inputs: Overlap_SuggestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uses up this week’s leftovers`)
};

const de_overlap_suggested = /** @type {(inputs: Overlap_SuggestedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwertet Reste dieser Woche`)
};

/**
* | output |
* | --- |
* | "Uses up this week’s leftovers" |
*
* @param {Overlap_SuggestedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const overlap_suggested = /** @type {((inputs?: Overlap_SuggestedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overlap_SuggestedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_overlap_suggested(inputs)
	return en_overlap_suggested(inputs)
});